import checkStatus from "../../../helpers/checkStatus"
import cleanObject from "../../../helpers/cleanObject"

import * as http from "./http"

export function contactAdd(formData) {
  cleanObject(formData)
  return http.contactAdd(formData)
  .then((res) => { return res.json() })
  .then(checkStatus)
  .catch((err) => {
    throw err
  })
}
